import { get, getTrackingString } from '../../../utils/object-helpers';

export default function cartButton(resp, variation) {
    if (!get(resp, 'addToCart', null)) {
        return;
    }

    let isAddedToCart = get(resp, 'isAddedToCart', false);
    if (variation) {
        isAddedToCart = get(variation, 'binModel.isAddedToCart', false);
    }

    if (isAddedToCart) { // View in cart
        let url = get(resp, 'addToCart.onCallToAction.action.URL', '');
        const params = get(resp, 'addToCart.onCallToAction.action.params', []);
        const query = [];
        for (const key in params) {
            if (key !== 'srt') {
                query.push(`${key}=${params[key]}`);
            }
        }
        url += `?${query.join('&')}`;

        return {
            type: 'viewInCart',
            label: get(resp, 'addToCart.onCallToAction.text', ''),
            url,
            tracking: getTrackingString(resp, 'addToCart.onCallToAction.action.trackingList')
        };
    } // Add to cart
    return {
        type: 'addToCart',
        label: get(resp, 'addToCart.offCallToAction.text', ''),
        tracking: getTrackingString(resp, 'addToCart.offCallToAction.action.trackingList')
    };
}
